module.exports = __webpack_public_path__ + "static/img/yu2.1d4eef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/yu2.png
// module id = yRQh
// module chunks = 0